export default "__VITE_ASSET__aSMIKoVjg9eBVhq93XNWlA__"